import { render, staticRenderFns } from "./RegulationRelatedSubstances.vue?vue&type=template&id=281392e6&scoped=true&"
import script from "./RegulationRelatedSubstances.vue?vue&type=script&lang=js&"
export * from "./RegulationRelatedSubstances.vue?vue&type=script&lang=js&"
import style0 from "./RegulationRelatedSubstances.vue?vue&type=style&index=0&id=281392e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281392e6",
  null
  
)

export default component.exports